/* global adminEventsListUrl adminEventsStoreUrl organisationUsersUrl currencies */

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import EventsCreateForm from './EventsCreateForm';

export default function EventsCreate() {
    return (
        <EventsCreateForm
            listEventsUrl={adminEventsListUrl}
            storeEventUrl={adminEventsStoreUrl}
            organisationUsersUrl={organisationUsersUrl}
            currencies={currencies}
        />
    );
}

if (document.getElementById('AdminEventsCreate')) {
    var rootEl = document.getElementById('AdminEventsCreate');
    ReactDOM.render(
        <App>
            <EventsCreate />
        </App>,
        rootEl,
    );
}
